module.exports = __webpack_public_path__ + "img/License.fab47c03.svg";